/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { Status } from '@dm/core';
import { ErrorData } from 'app/feature/monitor/task/task-center.service';
import { TaskStrService } from 'app/feature/monitor/task/task-str.service';

@Component({
    selector: 'app-task-error-detail',
    templateUrl: './task-error-detail.component.html',
    styleUrls: ['./task-error-detail.component.scss'],
})
export class TaskErrorDetailComponent implements OnInit {
    @Input() error: ErrorData;
    @Input() show = false;
    @Output() showChange = new EventEmitter<any>();

    i18nLabel = this.str.i18nLabel;
    statusText = this.str.statusText;
    brReg = /\\n/g;

    // 传给模板使用
    taskStatus = Status;

    constructor(
        private str: TaskStrService,
    ) { }

    ngOnInit(): void {
    }

    onClose(): void {
        this.show = false;
        this.showChange.emit(this.show);
    }
}
